


























import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
import Dropzone from "@/Ui-Components/Common/Uploader/Dropzone.vue";
import Listitem from "@/Ui-Components/Common/Uploader/Listitem.vue";
@Component(
	{
		name: "PdfUploader",
		components: {
			Dropzone,
			Listitem,
		}
	})
export default class PdfUploader extends Vue {
	@Prop() private multiple: boolean;
	@Prop() private uploading: boolean;
	@Prop() private uploadProgress: { [key: string]: { state: string; percentage: number } };
	@Prop() private maxFiles: number;

	private files: File[] = [];
	private successfullUploaded = false;
	private onFilesAdded(files: File[]) {
		files.sort((f1, f2) => f1.name.localeCompare(f2.name));
		if (this.multiple === true) {
			if (files.length > this.maxFiles) {
				this.$emit("partica-event",
					{
						action: eParticaAction.SHOW_SNACKBAR,
						item: `Maximum allowed PDF files to upload is ${this.maxFiles}`
					} as ParticaEvent);
				this.files = [];
				return;
			}
			this.files = [...files, ...this.files];
		} else {
			if (files.length > 1) {
				// this.ShowSnackbar("You can only drop a single PDF as a source.");
			} else {
				this.files = [];
				this.files.push(files[0]);
			}

		}
	}
	private clearFileList() {
		this.files = [];
		this.successfullUploaded = false;
	}
	private uploadFiles(e: any) {
		if (this.files.length > 0) {
			this.$emit("partica-event", { action: eParticaAction.PDF_UPLOAD, item: this.files, sourceEvent: e } as ParticaEvent);
		}
	}
}
